import { Wrench, Code } from 'lucide-react';
import { ExpandableSection } from '@/components/expandable-section';

interface ToolCallBlockProps {
  toolName: string;
  parameters?: Record<string, unknown>;
  result?: string;
  defaultExpanded?: boolean;
}

export function ToolCallBlock({ toolName, parameters, result, defaultExpanded = false }: ToolCallBlockProps) {
  return (
    <ExpandableSection
      title={`调用工具: ${toolName}`}
      icon={<Wrench size={14} />}
      defaultExpanded={defaultExpanded}
      variant="subtle"
    >
      <div className="space-y-2">
        {parameters && Object.keys(parameters).length > 0 && (
          <div>
            <p className="mb-1 flex items-center gap-1 text-xs text-muted-foreground">
              <Code size={12} />
              参数
            </p>
            <div className="rounded-md border border-border/20 bg-muted/10 p-2">
              <pre className="text-[11px] text-foreground">
                {JSON.stringify(parameters, null, 2)}
              </pre>
            </div>
          </div>
        )}
        {result && (
          <div>
            <p className="mb-1 text-xs text-muted-foreground">结果</p>
            <p className="text-xs text-foreground">{result}</p>
          </div>
        )}
      </div>
    </ExpandableSection>
  );
}
